var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"fill-rule":"nonzero","fill":"#85847C"}},[_c('path',{attrs:{"d":"M.353 3.557h11.294v1.467H.353zM.353.624h11.294v1.467H.353zM.353 6.49h11.294v1.467H.353zM.353 9.424h11.294v1.467H.353z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }